<template>
  <Layout
    class="onboarding-review"
    :title="page.title"
    :subtitle="page.subtitle"
  >
    <template #aboveTitle>
      <div class="onboarding-review__card">
        <div class="onboarding-review__stars">
          <span
            v-for="i in 5"
            :key="`star-${i}`"
            class="onboarding-review__star iconfont istar"
          ></span>
        </div>

        <p class="onboarding-review__text">{{ page.review }}</p>
        <p class="onboarding-review__author">{{ page.reviewer }}</p>
      </div>
    </template>
  </Layout>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { QuestionnaireView } from '@/models/onboarding'
import { ReviewPage } from '@/models/onboarding.types'

import Layout from '../Layout.vue'

const props = defineProps<{
  view: QuestionnaireView
}>()

const page = computed(() => {
  return props.view.currentPage as ReviewPage
})
</script>

<style lang="scss" scoped>
.onboarding-review {
  padding-inline: 0;
  padding-top: 0;
  background: $c-white;
  @media only screen and (min-width: $w-small) {
    background: $c-bg;
    justify-content: center;
  }

  + :deep(.onboarding-questionnaire__button-wrapper:after) {
    background: $c-white;
    @media only screen and (min-width: $w-small) {
      background: $c-bg;
    }
  }

  :deep(.onboarding-layout__above-title) {
    max-width: none;
    width: 100%;
    background: $c-bg;
    padding: var(--onboarding-padding);
    margin-bottom: var(--onboarding-padding);
    border-radius: 0 0 20px 20px;
    min-height: 0;
    @media only screen and (min-width: $w-small) {
      margin: 0;
      padding-bottom: calc(var(--onboarding-padding) * 2);
      background: transparent;
    }
    @media only screen and (max-height: 710px) {
      padding-bottom: calc(var(--onboarding-padding) / 2);
      margin-bottom: calc(var(--onboarding-padding) / 2);
    }
  }

  :deep(.onboarding-layout__text) {
    flex: 1;
    padding-inline: var(--onboarding-padding);
  }

  &__card {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 32px 20px;
    border-radius: 12px;
    background: $c-black-15;
    max-width: var(--onboarding-inner-width);
    max-height: 100%;
    margin: auto;
    @media only screen and (max-height: 710px) {
      padding-block: 20px;
      gap: 8px;
    }
  }

  &__star {
    font-size: 32px;
    color: $c-yellow;
  }

  &__text {
    font-size: 16px;
    line-height: 24px;
    margin: 0;
    color: $c-bg;
    overflow-y: scroll;
  }

  &__author {
    position: relative;
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    text-transform: uppercase;
    color: $c-black-6;

    &:before {
      content: '— ';
    }

    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: -16px;
      display: block;
      z-index: 3;
      width: 100%;
      height: 16px;
      background: linear-gradient(0deg, $c-black-15 50%, rgba($c-black-15, 0));
    }
  }
}
</style>
